import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
    box:{

        margin:10,
     
        
        
        
        },
        paper:{
            padding:10,
            boxShadow:"1px",
     
        },
        statusBox:{
          backgroundColor:theme.palette.primary.main,
          borderRadius:10,
          color:"white",
          
          width:"100px",
          padding:10,
          textAlign:"center",
          
          fontSize:9
            },
        row:{
display:"grid",


gridTemplateColumns: "auto auto auto",

justifyContent: "center",
  alignItems: "center",


gridColumnGap: "30px",
[theme.breakpoints.between("xs", "md")]: {
  gridTemplateColumns: "auto",

  justifyContent: "center",
  alignItems: "center",
},
        },
    btn:{
        width:"120px",
      marginRight:10,
      marginTop:10,
    fontSize:11,
    padding:8,
    transition: "background 1s, color 2s",
    "&:hover": {
    backgroundColor:theme.palette.secondary.main,
    color:"white"
    }
    }
}));
